import { JSONEditor } from '@json-editor/json-editor'
import _ from 'lodash'

const StringEditor = JSONEditor.defaults.editors.string

class EnumSourceHelper extends StringEditor {
  build () {
    this.active = false // this will prevent the value of this editor from being included in the final data

    this.input_type = 'text'
    this.input = this.theme.getFormInputField(this.input_type)
    this.container.classList.add('compact')
    this.disable(true)
    this.input.setAttribute('readonly', 'true')

    const { input } = this
    this.control = this.theme.getFormControl(this.label, input, this.description, this.infoButton, this.formname)
    this.container.appendChild(this.control)

    /* Compile and store the template */
    const sourceName = this.options.source
    const valueProp = this.options.valueProp

    // automatically create template
    this.schema.template = `<%=#${sourceName}%><%=${valueProp}%><%=/${sourceName}%>`
    this.template = this.jsoneditor.compileTemplate(this.schema.template, this.template_engine)

    this.refreshValue()
  }

  getValue () {
    const hasValueSet = !!(this.input && this.input.value)
    if (!hasValueSet) {
      return undefined
    }

    const vars = this.getWatchedFieldValues()
    const sourceObj = _.get(vars, this.options.source, {})
    if (!sourceObj) {
      return {}
    }
    return sourceObj.map((item) => {
      let title = item[this.options.titleProp]
      if (title.length > 30) {
        title = `${title.substring(0, 30)}...`
      }
      return {
        value: item[this.options.valueProp],
        title: `${item[this.options.valueProp]}: ${title}`
      }
    })
  }
}

export default EnumSourceHelper
